const BUG_NUMBER_KEYS = ['bug_number', 'Bug_number', 'bugNumber'] as const;
const PIPE_DIAMETER_KEYS = ['pipe_diameter', 'Pipe_diameter', 'pipeDiameter'] as const;
const BAND_DIAMETER_KEYS = ['band_diameter', 'Band_diameter', 'bandDiameter'] as const;
const WELD_LENGTH_KEYS = ['weld_length', 'Weld_length', 'weldLength'] as const;

type RecordLike = unknown;

const asFieldRecord = (record: RecordLike): Record<string, unknown> | null => {
  if (!record || typeof record !== 'object') return null;
  return record as Record<string, unknown>;
};

const pickFromRecord = (record: RecordLike, keys: readonly string[]): unknown => {
  const fieldRecord = asFieldRecord(record);
  if (!fieldRecord) return null;

  for (const key of keys) {
    const value = fieldRecord[key];
    if (value !== null && value !== undefined && value !== '') {
      return value;
    }
  }

  const nested = asFieldRecord(fieldRecord.pass_view ?? fieldRecord.passView);
  if (nested) {
    for (const key of keys) {
      const value = nested[key];
      if (value !== null && value !== undefined && value !== '') {
        return value;
      }
    }
  }

  return null;
};

export const pickFirstDefined = (record: RecordLike, keys: readonly string[]): unknown =>
  pickFromRecord(record, keys);

export const parsePassNumeric = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(num) ? num : null;
};

export const resolvePassBugNumber = (...sources: RecordLike[]): string | null => {
  for (const source of sources) {
    const value = pickFromRecord(source, BUG_NUMBER_KEYS);
    if (value !== null && value !== undefined && value !== '') {
      return String(value);
    }
  }
  return null;
};

export const resolvePassPipeDiameter = (...sources: RecordLike[]): number | null => {
  for (const source of sources) {
    const parsed = parsePassNumeric(pickFromRecord(source, PIPE_DIAMETER_KEYS));
    if (parsed !== null) return parsed;
  }
  return null;
};

export const resolvePassBandDiameter = (...sources: RecordLike[]): number | null => {
  for (const source of sources) {
    const parsed = parsePassNumeric(pickFromRecord(source, BAND_DIAMETER_KEYS));
    if (parsed !== null) return parsed;
  }
  return null;
};

export const resolvePassWeldLength = (...sources: RecordLike[]): number | null => {
  for (const source of sources) {
    const parsed = parsePassNumeric(pickFromRecord(source, WELD_LENGTH_KEYS));
    if (parsed !== null) return parsed;
  }
  return null;
};
